<template>
  <div class="disposal-item-component" :class="{ 'is-mobile': isMobile }">
    <!-- 头部信息 -->
    <div class="item-header flex-center">
      <div class="header-info">
        <span class="label">就诊时间</span>
        <span class="value">{{ disposalItem.appointTime }}</span>
        <span class="label">医生</span>
        <span class="doctor-name">{{ disposalItem.doctorName }}</span>
      </div>
    </div>

    <!-- 展开内容 -->
    <div class="item-content">
      <!-- 项目列表 -->
      <div
        class="project-item"
        v-for="(project, pIndex) in disposalItem.details"
        :key="pIndex"
      >
        <div class="row flex-center">
          <!-- 牙位图 -->
          <div class="tooth-map" v-if="project.fdiToothCodes">
            <H5ToothMap 
            :toothPosition="project.fdiToothCodes"
            style="width:3.6rem;margin-left:0.2rem;margin-right:0.2rem;"
            />
          </div>

          <!-- 项目名称 -->
          <div class="project-name">{{ project.chargeItemName }}</div>
        </div>

        <!-- 项目详情 -->
        <div class="project-details">
          <div class="detail-row">
            <span class="detail-label">单价</span>
            <span class="detail-value">{{ project.price }}</span>
            <span class="detail-label">数量</span>
            <span class="detail-value">{{ project.count }}</span>
            <span class="detail-label">质保</span>
            <span class="detail-value">{{
              $filters.warrantydatekh(project.warrantyMonths) || "无"
            }}</span>
          </div>
        </div>
      </div>

      <!-- 底部汇总信息 -->
      <div class="summary-info">
        <div class="summary-row">
          <div>
            <span class="summary-label">总价</span>
            <span class="summary-value">{{ disposalItem.totalPrice }}</span>
          </div>
          <div>
            <span class="summary-label">应收</span>
            <span class="summary-value">{{ disposalItem.planAmount }}</span>
          </div>
          <div>
            <span class="summary-label">已收</span>
            <span class="summary-value">{{ disposalItem.actualAmount }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ToothMap from "@/components/publick/h5toothmap.vue";

export default {
  name: "DisposalItem",
  components: {
 
  },
  props: {
    // 是否为移动端模式，默认true使用rem，false使用px
    isMobile: {
      type: Boolean,
      default: true,
    },
    // 单个处置项数据
    disposalItem: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.disposal-item-component {
  border: 1px solid #e6e6e6;
  overflow: hidden;
  background-color: #fff;
  text-align: left;

  // 移动端样式（使用rem）
  &.is-mobile {
    font-size: 0.292rem;
    border-radius: 0.083rem;

    .item-header {
      padding: 0.208rem 0.167rem 0.167rem;

      .item-header-icon {
        font-size: 0.375rem;
        margin-right: 0.083rem;
        padding-bottom: 0.042rem;
      }

      .header-info {
        .label {
          margin-right: 0.167rem;
          flex-shrink: 0;
        }

        .value {
          margin-right: 0.25rem;
          flex-shrink: 0;
        }

        .doctor-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .item-content {
      padding: 0.25rem 0.208rem;

      .project-item {
        padding-bottom: 0.167rem;
        margin-bottom: 0.167rem;

        .tooth-map {
          max-width: 5.417rem;
          margin-right: 0.167rem;
        }

        .project-details {
          .detail-row {
            margin-top: 0.167rem;
            gap: 0.25rem;

            .detail-label {
              min-width: 0.5rem;
            }
          }
        }
      }

      .summary-info {
        margin-top: 0.167rem;

        .summary-row {
          gap: 0.25rem;
          .summary-label {
            min-width: 0.5rem;
            margin-right: 0.083rem;
          }
        }
      }
    }
  }

  // PC端样式（使用px）
  &:not(.is-mobile) {
    font-size: 14px;
    text-align: left;
    border-radius: 4px;

    .item-header {
      padding: 12px 8px;

      .item-header-icon {
        font-size: 18px;
        margin-right: 4px;
        padding-bottom: 2px;
      }

      .header-info {
        font-size: 14px;

        .label {
          margin-right: 8px;
        }

        .value {
          margin-right: 16px;
        }

        .doctor-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .item-content {
      padding: 16px 12px;

      .project-item {
        padding-bottom: 12px;
        margin-bottom: 12px;

        .tooth-map {
          max-width: 260px;
          margin-right: 8px;
        }

        .project-details {
          .detail-row {
            margin-top: 8px;
            gap: 12px;

            .detail-label {
              min-width: 24px;
            }
          }
        }
      }

      .summary-info {
        margin-top: 8px;

        .summary-row {
          gap: 12px;
          .summary-label {
            min-width: 24px;
            margin-right: 4px;
          }
        }
      }
    }
  }

  // 通用样式
  .item-header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;

    .item-header-icon {
      color: #28b8c3;
      flex-shrink: 0;
    }

    .header-info {
      flex: 1;
      display: flex;
      align-items: center;
      line-height: 1;

      .label {
        color: #666;
      }

      .value {
        color: #333;
        font-weight: 500;
      }

      .doctor-name {
        color: #333;
      }
    }
  }

  .item-content {
    .project-item {
      border-bottom: 1px solid #e6e6e6;

      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
      }

      .tooth-map {
        flex: 2 0;
      }

      .project-name {
        flex: 3;
        color: #333;
        font-size: .271rem;
      }

      .project-details {
        .detail-row {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          line-height: 1.5;

          .detail-label {
            color: #666;
          }

          .detail-value {
            color: #333;
          }
        }
      }
    }

    .summary-info {
      .summary-row {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .summary-label {
          color: #666;
        }

        .summary-value {
          color: #333;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
